import { inject, Injectable } from '@angular/core';
import { AppGlobalControlValues } from 'src/app/common/app.global.control.values';
import { OperationInfoService } from 'src/app/common/long-operations/operation-info.service';
import { ActionBtnInfo } from 'src/app/interfaces/views.interface';
import { SocialInitiative } from '../shared/social-initiative/social-initiative.abstract';
import { SocialGroupType } from './search-component/invite-to-social-group/social-group.interface';
@Injectable({ providedIn: 'root' })
export class ActionsHandlerService {
  private operationInfoService = inject(OperationInfoService);
  private socialInitiative = inject(SocialInitiative, { skipSelf: true });

  public handleAction(
    inviteType: SocialGroupType,
    entityId: string,
    btnInfo: ActionBtnInfo,
    acceptButton = false,
  ): void {
    // TODO: move texting to socialInitiative service

    let successfulMessage: string;

    if (acceptButton) {
      successfulMessage =
        inviteType === 'Community'
          ? 'MANAGE_COMMUNITY_CONFIRM_USER_REQUEST_HINT'
          : 'MANAGE_PROJECT_CONFIRM_USER_REQUEST_HINT';
    } else {
      successfulMessage =
        inviteType === 'Community'
          ? 'MANAGE_COMMUNITY_INVITE_TO_COMMUNITY_SUCCESS_HINT'
          : 'MANAGE_PROJECT_INVITE_TO_PROJECT_SUCCESS_HINT';
    }

    this.operationInfoService.setupOperation(
      {
        spinner: 'button',
        button: { id: btnInfo.dataTestId },
        successfulMessage: successfulMessage,
        blockedUIControls: [{ elementId: AppGlobalControlValues.LOG_OUT_BUTTON }],
      },
      () => {
        this.socialInitiative.inviteToEntity(btnInfo.actionBtnId, entityId);
      },
    );
  }
}
